import OverviewPage from './pages/OverviewPage';
import ApiStatusPage from './pages/ApiStatusPage';
import SystemPage from './pages/SystemPage';
import CredentialsPage from './pages/CredentialsPage';
import CloneProviderPage from './pages/CloneProviderPage';

export const ROUTES = {
  overview: {
    key: 'overview',
    title: 'Overview',
    label: 'Overview',
    path: '/overview',
    element: <OverviewPage />,
  },
  apiStatus: {
    key: 'apiStatus',
    title: 'API Status',
    label: 'API Status',
    path: '/api-status',
    element: <ApiStatusPage />,
  },
  system: {
    key: 'system',
    title: 'AK API Panel',
    label: 'AK API Panel',
    path: '/panel/akapi',
    element: <SystemPage />,
  },
  credentials: {
    key: 'credentials',
    title: 'Credentials',
    label: 'Credentials',
    path: '/credentials',
    element: <CredentialsPage />,
  },
  cloneProvider: {
    key: 'cloneProvider',
    title: 'Clone Provider',
    label: 'Clone Provider',
    path: '/panel/clone-provider',
    element: <CloneProviderPage />,
  },
};

export const routeList = Object.values(ROUTES);